import form from './form';

const component = { form };

export default component;
